export const Colors = {
    black: [0, 0, 0],
    darkGray: [119, 119, 119],
    lightGray: [216, 216, 216],
    white: [255, 255, 255],
    blue: [0, 160, 223],
    darkBlue: [29, 52, 97], 
    lightBlue: [102, 198, 236],
    red: [255, 0, 0],
    green: [111, 228, 91],
}; 

export function Color([r, g, b], opacity = 1) {
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}